export default __webpack_public_path__ + "static/media/logos.7e7ae99e.PNG";